import { Component, ContentChild, ElementRef, OnInit } from '@angular/core';

@Component({
  selector: 'box',
  templateUrl: './box.component.html',
  styleUrls: ['./box.component.scss']
})
export class BoxComponent {

  @ContentChild("content") content!: ElementRef;
  
  constructor() { }

}
